module.exports = __webpack_public_path__ + "static/media/reddram.6eb12228.svg";